var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  staticClass: "flex-1",
                  attrs: {
                    filterable: "",
                    placeholder: _vm.$t("pleaseChoose")
                  },
                  on: { change: _vm.envIdChange },
                  model: {
                    value: _vm.paramsData.env_id,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "env_id", $$v)
                    },
                    expression: "paramsData.env_id"
                  }
                },
                _vm._l(_vm.szgmEnv, function(item) {
                  return _c("el-option", {
                    key: item.label,
                    attrs: { label: item.label, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    filterable: "",
                    placeholder: _vm.$t("serverChannel")
                  },
                  on: { change: _vm.serverChange },
                  model: {
                    value: _vm.server_channel,
                    callback: function($$v) {
                      _vm.server_channel = $$v
                    },
                    expression: "server_channel"
                  }
                },
                _vm._l(_vm.serverChannel, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("showTestServer")
                  },
                  on: { change: _vm.serverChannelChange },
                  model: {
                    value: _vm.show_test,
                    callback: function($$v) {
                      _vm.show_test = $$v
                    },
                    expression: "show_test"
                  }
                },
                _vm._l(_vm.serverType, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    multiple: "",
                    "collapse-tags": "",
                    filterable: "",
                    placeholder: _vm.$t("server")
                  },
                  on: { change: _vm.severChange },
                  model: {
                    value: _vm.paramsData.server_id,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "server_id", $$v)
                    },
                    expression: "paramsData.server_id"
                  }
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      on: { change: _vm.selectAll },
                      model: {
                        value: _vm.checked,
                        callback: function($$v) {
                          _vm.checked = $$v
                        },
                        expression: "checked"
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("selectAll")) + " ")]
                  ),
                  _vm._l(_vm.serverListYJ, function(item) {
                    return _c("el-option", {
                      key: item.serverID,
                      attrs: { label: item.serverName, value: item.serverID }
                    })
                  })
                ],
                2
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: {
                  clearable: "",
                  filterable: "",
                  placeholder: _vm.$t("reporterRoleId")
                },
                model: {
                  value: _vm.paramsData.reporter_id,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "reporter_id", $$v)
                  },
                  expression: "paramsData.reporter_id"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: {
                  clearable: "",
                  filterable: "",
                  placeholder: _vm.$t("reportedRoleId")
                },
                model: {
                  value: _vm.paramsData.reported_id,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "reported_id", $$v)
                  },
                  expression: "paramsData.reported_id"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c("el-date-picker", {
                attrs: {
                  clearable: false,
                  "picker-options": _vm.pickerOptionsRadius,
                  "value-format": "timestamp",
                  type: "datetimerange",
                  "start-placeholder": _vm.$t("startTime"),
                  "end-placeholder": _vm.$t("endTime")
                },
                model: {
                  value: _vm.date,
                  callback: function($$v) {
                    _vm.date = $$v
                  },
                  expression: "date"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("operator")
                  },
                  model: {
                    value: _vm.paramsData.admin_id,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "admin_id", $$v)
                    },
                    expression: "paramsData.admin_id"
                  }
                },
                _vm._l(_vm.userList, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.nickname, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.getList(1)
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("search")) + " ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.reqLoading,
              expression: "reqLoading"
            }
          ],
          attrs: { data: _vm.tableData, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "server_name", label: _vm.$t("serverName") }
          }),
          _c("el-table-column", {
            attrs: { prop: "reporter_id", label: _vm.$t("reporterId") }
          }),
          _c("el-table-column", {
            attrs: { prop: "reporter_name", label: _vm.$t("reporterName") }
          }),
          _c("el-table-column", {
            attrs: { prop: "reported_id", label: _vm.$t("reportedId") }
          }),
          _c("el-table-column", {
            attrs: { prop: "reported_name", label: _vm.$t("reportedName") }
          }),
          _c("el-table-column", {
            attrs: { prop: "report_time", label: _vm.$t("reportTime") }
          }),
          _c("el-table-column", {
            attrs: { prop: "report_reason", label: _vm.$t("reportReason") }
          }),
          _c("el-table-column", {
            attrs: { prop: "status", label: _vm.$t("operationStatus") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    row.status == 0
                      ? _c("div", [_vm._v(_vm._s(_vm.$t("pendingReview")))])
                      : _vm._e(),
                    row.status == 1
                      ? _c("div", [_vm._v(_vm._s(_vm.$t("reviewNotTrue")))])
                      : _vm._e(),
                    row.status == 2
                      ? _c("div", [
                          _vm._v(_vm._s(_vm.$t("reviewTrueAndBanned")))
                        ])
                      : _vm._e(),
                    row.status == 3
                      ? _c("div", [_vm._v(_vm._s(_vm.$t("expired")))])
                      : _vm._e(),
                    row.status == 4
                      ? _c("div", [_vm._v(_vm._s(_vm.$t("unsealed")))])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "approve_admin_id", label: _vm.$t("operator") }
          }),
          _c("el-table-column", {
            attrs: { prop: "approve_timestamp", label: _vm.$t("operationTime") }
          }),
          _c("el-table-column", {
            attrs: { prop: "approve_reason", label: _vm.$t("operationReason") }
          }),
          _c("el-table-column", {
            attrs: { label: _vm.$t("operation"), width: "160", fixed: "right" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", { staticClass: "x-c" }, [
                      row.status == 0
                        ? _c(
                            "div",
                            {
                              staticClass: "controlsBtn",
                              on: {
                                click: function($event) {
                                  return _vm.punishItem(row)
                                }
                              }
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("ban")) + " ")]
                          )
                        : _vm._e(),
                      row.status == 3
                        ? _c("div", { staticClass: "controlsBtn" }, [
                            _vm._v(_vm._s(_vm.$t("expired")))
                          ])
                        : _vm._e(),
                      row.status == 2
                        ? _c(
                            "div",
                            {
                              staticClass: "controlsBtn",
                              on: {
                                click: function($event) {
                                  return _vm.unsealClick(row)
                                }
                              }
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("unban")) + " ")]
                          )
                        : _vm._e()
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          layout: "total,sizes, prev, pager, next",
          "current-page": _vm.paramsData.page,
          total: _vm.total
        },
        on: { "current-change": _vm.getList, "size-change": _vm.sizeChange }
      }),
      _c("addEmperor", {
        ref: "addEmperor",
        attrs: { propsData: { env_id: _vm.paramsData.env_id } },
        on: {
          change: function($event) {
            return _vm.getList(_vm.paramsData.page)
          }
        }
      }),
      _c("unseal", {
        ref: "unseal",
        attrs: { propsData: { env_id: _vm.paramsData.env_id } },
        on: {
          change: function($event) {
            return _vm.getList(_vm.paramsData.page)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }